<template>
  <div id="app" :style="style" v-loading="isLoading">
    <router-view></router-view>
  </div>
</template>

<script>
import apis from './request/api';
const HEIGHT =
  document.body.clientHeight || document.documentElement.clientHeight;
const winWIDTH =
  document.body.clientWidth || document.documentElement.clientWidth;
export default {
  name: 'app',
  data() {
    return {
      isLoading: false,
      style: {
        width: winWIDTH + 'px',
        'min-height': HEIGHT + 'px'
      }
    };
  },
  components: {},
  mounted() {},
  created() {
    // ★★★挂载全局api
    for (const key in apis) {
      this.$root[key] = apis[key];
    }
  }
};
</script>

<style>
#app {
  background: #f6f6f6;
  box-sizing: border-box;
  /* display: flex; 新版本语法: Opera 12.1, Firefox 22+ */
  /* display: -webkit-flex; 新版本语法: Chrome 21+ */
  /* flex-flow: row nowrap; */
  /* justify-content: center; */
  /* align-items: center */
}
</style>
